import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { getEmployeeTreeApi } from "../../../apiServices/adminWork.services";

const TreeNode = ({ user }) => {
  return (
    <div className="tree-node-wrapper">
      <div className="tree-card">
        <div className="tree-avatar">
          {user?.firstName?.charAt(0)}
          {user?.lastName?.charAt(0)}
        </div>

        <div className="tree-content">
          <h5>
            {user.firstName} {user.lastName}
          </h5>

          <div className="tree-designation">
            {user.designationId?.title || "No Designation"}
          </div>

          <div className="tree-department">
            {user.departmentId?.name || "No Department"}
          </div>
        </div>
      </div>

      {user?.children?.length > 0 && (
        <>
          <div className="tree-line-vertical" />

          <div className="tree-children">
            {user.children.map((child) => (
              <div
                key={child._id}
                className="tree-child-item"
              >
                <TreeNode user={child} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const UserTree = ({ selectedUser }) => {

  const [tree, setTree] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTree = async () => {
    try {

      setLoading(true);

      const res = await getEmployeeTreeApi(
        selectedUser?._id
      );

      setTree(res?.data || null);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    if (selectedUser?._id) {
      fetchTree();
    }

  }, [selectedUser]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!tree) {
    return (
      <div className="text-center py-5">
        <h5>No Hierarchy Found</h5>
      </div>
    );
  }

  return (
    <div className="tree-container">

      <div className="tree-title">

        <h4>
          Employee Reporting Hierarchy
        </h4>

        <p>
          Complete reporting structure of{" "}
          <strong>
            {selectedUser?.firstName}{" "}
            {selectedUser?.lastName}
          </strong>
        </p>
      </div>

      <div className="tree-root">
        <div className="tree-node-wrapper">

          {tree.reportingManagerId && (
            <>
              <div className="tree-card">
                <div className="tree-avatar">
                  {tree.reportingManagerId.firstName?.charAt(0)}
                  {tree.reportingManagerId.lastName?.charAt(0)}
                </div>

                <div className="tree-content">
                  <h5>
                    {tree.reportingManagerId.firstName}{" "}
                    {tree.reportingManagerId.lastName}
                  </h5>

                  <div className="tree-designation">
                    {tree.reportingManagerId.designationId?.title || "No Designation"}
                  </div>

                  <div className="tree-department">
                    {tree.reportingManagerId.departmentId?.name || ""}
                  </div>
                </div>
              </div>

              <div className="tree-line-vertical" />
            </>
          )}

          <TreeNode user={tree} />

        </div>
      </div>
    </div>
  );
};

export default UserTree;